import { gql, useQuery } from "@apollo/client";
import { useLnRouterAuth } from "../../auth/useLnRouterAuth";
import { GraphQlQueryResponse } from "../../general/GraphQlQueryResponse";



const QUERY = gql`
query IsPeerOf($peerId: String!) {
  IsPeerOfMe(peerId: $peerId) 
}`;



export function useIsMyPeer(peerId: string): GraphQlQueryResponse<boolean> {
  const auth = useLnRouterAuth();
  auth.loading
  const query = useQuery(QUERY, {
    variables: { 
      peerId: peerId 
    },
    skip: !auth.isLoggedIn
  }
  );
  const connected = query.data?.IsPeerOfMe;

  return {
    loading: query.loading,
    error: query.error,
    data: connected,
    refetch: query.refetch
  };
}